import api from '../utils/api';

// ==================== Device Types API ====================

/**
 * Get all device types with pagination and filters
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Response with data and meta
 */
export const getAllDeviceTypes = async (params) => {
  const response = await api.get('/device-types', params);
  return response;
};

/**
 * Get device type by ID
 * @param {number} id - Device type ID
 * @returns {Promise<Object>} Device type data
 */
export const getDeviceTypeById = async (id) => {
  const response = await api.get(`/device-types/${id}`);
  return response;
};

/**
 * Get initialization data for device type form
 * @returns {Promise<Object>} Init data
 */
export const getDeviceTypeInit = async () => {
  const response = await api.get('/device-types/init');
  return response;
};

/**
 * Create a new device type
 * @param {Object} data - Device type data
 * @returns {Promise<Object>} Created device type
 */
export const createDeviceType = async (data) => {
  const response = await api.post('/device-types', data);
  return response;
};

/**
 * Update an existing device type
 * @param {number} id - Device type ID
 * @param {Object} data - Device type data
 * @returns {Promise<Object>} Updated device type
 */
export const updateDeviceType = async (id, data) => {
  const response = await api.put(`/device-types/${id}`, { id, ...data });
  return response;
};

/**
 * Delete a device type
 * @param {number} id - Device type ID
 * @returns {Promise<Object>} Deletion response
 */
export const deleteDeviceType = async (id) => {
  const response = await api.delete(`/device-types/${id}`);
  return response;
};

/**
 * Bulk delete device types
 * @param {Array<number>} ids - Array of device type IDs
 * @returns {Promise<Object>} Deletion response
 */
export const bulkDeleteDeviceTypes = async (ids) => {
  const response = await api.delete('/device-types', {
    params: { ids },
    paramsSerializer: {
      indexes: null,
    },
  });
  return response;
};

// ==================== Verify Modes API ====================

/**
 * Get all verify modes with pagination and filters
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Response with data and meta
 */
export const getAllVerifyModes = async (params) => {
  const response = await api.get('/verify-modes', params);
  return response;
};

/**
 * Get verify mode by ID
 * @param {number} id - Verify mode ID
 * @returns {Promise<Object>} Verify mode data
 */
export const getVerifyModeById = async (id) => {
  const response = await api.get(`/verify-modes/${id}`);
  return response;
};

/**
 * Get initialization data for verify mode form
 * @returns {Promise<Object>} Init data
 */
export const getVerifyModeInit = async () => {
  const response = await api.get('/verify-modes/init');
  return response;
};

/**
 * Create a new verify mode
 * @param {Object} data - Verify mode data
 * @returns {Promise<Object>} Created verify mode
 */
export const createVerifyMode = async (data) => {
  const response = await api.post('/verify-modes', data);
  return response;
};

/**
 * Update an existing verify mode
 * @param {number} id - Verify mode ID
 * @param {Object} data - Verify mode data
 * @returns {Promise<Object>} Updated verify mode
 */
export const updateVerifyMode = async (id, data) => {
  const response = await api.put(`/verify-modes/${id}`, { id, ...data });
  return response;
};

/**
 * Delete a verify mode
 * @param {number} id - Verify mode ID
 * @returns {Promise<Object>} Deletion response
 */
export const deleteVerifyMode = async (id) => {
  const response = await api.delete(`/verify-modes/${id}`);
  return response;
};

/**
 * Bulk delete verify modes
 * @param {Array<number>} ids - Array of verify mode IDs
 * @returns {Promise<Object>} Deletion response
 */
export const bulkDeleteVerifyModes = async (ids) => {
  const response = await api.delete('/verify-modes', {
    params: { ids },
    paramsSerializer: {
      indexes: null,
    },
  });
  return response;
};
